var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-15"},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"300","height":"300","margin":"16","accept":"image/*","size":"10","button-class":"changeBtn","prefill":_vm.prefillImage,"custom-strings":{
                      upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                      drag: 'Arraste uma imagem <br> (ou clique aqui)',
                      change: 'Mudar foto',
                    }},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }